import styled from 'styled-components';

export const GuestHeader = () => {
    return (
        <HeaderWrapper>
            <ContentWrapper>
                <Title>
                    ¡Hola! Fuiste invitado a unirte a <span>ADEN</span>
                </Title>
                <Subtitle>
                    Un alumno de nuestra comunidad cree que ADEN es ideal para
                    ti. Si te inscribes desde este enlace, tu proceso será más
                    fácil.
                </Subtitle>
            </ContentWrapper>
        </HeaderWrapper>
    );
};

const HeaderWrapper = styled.header`
    width: calc(100% - 10rem);
    padding: 1rem 4rem;
    display: flex;

    @media (width < 768px) {
        padding: 1rem 2rem;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    span {
        color: #b31d15;
    }
`;

const Title = styled.h2``;

const Subtitle = styled.p``;
